import { Redirect } from "react-router"
import { myLazy } from "utils/myLazy"
import { GooglePageViewTypes } from "utils/googleAnalytics/googleAnalyticsPageViewEvent"

export const adminUserRoutes = [
  // {
  //   exact: true,
  //   path: "/admin/user/list", // API failure
  //   component: myLazy(() => import("../views/admin/user/userList")), // next || progress ===============================================
  // },

  {
    exact: true,
    path: "/admin/user/client/list",
    component: myLazy(() => import("../views/admin/user/userList")), //Localization done Balazs
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Lista de utilizatori"
  },

  {
    exact: false,
    path: "/admin/user/client/form",
    component: myLazy(() => import("../views/admin/user/userForm")), //Localization done Balazs
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Utilizatori"
  },
  {
    exact: true,
    path: "/admin/user/uni/list",
    component: myLazy(() => import("../views/admin/angajati/List")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Angajați Uniprest Instal"
  },
  //missing uniprest form
  {
    exact: false, //added for missing uniuser form => branch feature/istvan/admin/uniuser/form
    path: "/admin/user/uni/form",
    component: myLazy(() => import("views/admin/angajati/uniUserForm.jsx")),
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Angajați Uniprest Instal"
  },
  {
    exact: false,
    path: "/admin/user/role/list",
    component: myLazy(() => import("../views/admin/rolesTable/rolesForm")),
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Lista de roluri"
  },

  {
    exact: false,
    path: "/admin/user/role/form",
    component: myLazy(() => import("../views/admin/user/roleForm")),
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Lista de roluri"
  },

  {
    exact: true,
    path: "/admin/user/dashboard",
    component: myLazy(() => import("../views/admin/unifiedDashboard")), //Localization done Balazs
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Dashboard"
  },

  {
    exact: false,
    path: "/admin/user",
    component: () => <Redirect to="/admin/user/dashboard" />,
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Dashboard"
  }
]
